import React, { useState } from 'react';
import GetIcon from '../../../utils/Icon';
import VersionHistory from '../../../utils/VersionHistory';

function Tab1({ fulldata, order_id, activityboll, picklist_id }) {
    console.log(fulldata, "fulldata");

    const [showActivity, setShowActivity] = useState(true);

    return (
        <div
            className="row sidebarbox m-0"
            style={{ padding: "8px", borderRadius: "5px", height: '74vh', overflowY: 'scroll' }}
        >
            {/* Top Section */}
            <div style={{ height: '28vh' }}>
                     <div className="d-flex gap-2 mb-2">
          <div className="col">
                        <div className=" position-relative floating-date-wrapper">
                            <input
                                type="text"
                                id="deliveryDate"
                                className="form-control custom-date-input floating-date-input custom-readonly"
                                style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '30px' }}
                                value={order_id}
                                readOnly
                            />
                            <label htmlFor="deliveryDate" className="custom-date-label active-tab customBGTWo">Pick Id</label>
                        </div>
                    </div>

          <div className="col">
                        <div className="mb-1">
                            <div className="custom-date-wrapper">
                                <label className="custom-date-label active-tab customBGFive" htmlFor="orderdatepo">Order Date</label>
                                <input
                                    type="date"
                                    id="orderdatepo"
                                    className="form-control custom-date-input custom-readonly"
                                    style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '30px' }}
                                    value="2025-05-20"
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="position-relative floating-select-wrapper">
                        <div
                            className="form-control custom-date-input floating-select-input custom-readonly"
                            style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '30px' }}
                        >
                            {fulldata?.message.purpose}
                        </div>
                        <label className="custom-date-label active-tab customBGTWo">Purpose</label>
                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="position-relative floating-select-wrapper">
                        <div
                            className="form-control custom-date-input floating-select-input custom-readonly"
                            style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '30px' }}
                        >
                            {fulldata?.message?.work_order}
                        </div>
                        <label className="custom-date-label active-tab customBGFive">Work Order</label>
                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="mb-3 position-relative floating-date-wrapper">
                        <input
                            type="date"
                            id="deliveryDate"
                            className="form-control custom-date-input floating-date-input custom-readonly"
                            style={{ fontSize: '0.8rem', padding: '0.375rem 11px', height: '30px' }}
                            value="2025-05-22"
                            readOnly
                        />
                        <label htmlFor="deliveryDate" className="custom-date-label active-tab customBGFive">Delivery Date</label>
                    </div>
                </div>
            </div>

            {/* Middle Section */}
            <div style={{ marginTop: '-35px', height: '28vh' }}>
                <div>
                    <div className='d-flex pb-2'>
                        <input checked type="checkbox" style={{ width: '15px', height: '15px', marginRight: '5px' }} />
                        <label style={{ color: '#00000099', fontSize: '13px', marginTop: '-5px' }}>Consider Rejected Warehouses</label>
                    </div>
                    <p style={{ fontSize: '9px', color: '#00000099', marginTop: '-5px', marginLeft: '25px' }}>
                        Items under this warehouse will be suggested
                    </p>
                </div>

                <div className='' style={{ marginTop: '-10px', marginBottom: '11px' }}>
                    <input
                        type="text"
                        id="numberInput"
                        className="form-control"
                        placeholder="Remarks"
                        style={{ borderRadius: '6px', fontSize: '11px', height: '38px' }}
                        defaultValue=""
                    />
                </div>

                <div>
                    <div className='d-flex pb-2'>
                        <input checked type="checkbox" style={{ width: '15px', height: '15px', marginRight: '5px' }} />
                        <label style={{ color: '#00000099', fontSize: '13px', marginTop: '-5px' }}>Pick Manually</label>
                    </div>
                    <p style={{ fontSize: '9px', color: '#00000099', marginTop: '-5px', marginLeft: '25px' }}>
                        If enabled then system won't override the picked qty / batches / serial numbers.
                    </p>
                </div>

                <div>
                    <div className='d-flex pb-2' style={{ marginTop: '-11px' }}>
                        <input checked type="checkbox" style={{ width: '15px', height: '15px', marginRight: '5px' }} />
                        <label style={{ color: '#00000099', fontSize: '14px', marginTop: '-5px' }}>Ignore Pricing Rule</label>
                    </div>
                    <p style={{ fontSize: '9px', color: '#00000099', marginTop: '-4px', marginLeft: '25px' }}>
                        If enabled then system won't apply the pricing rule on the delivery note which will be created from the pick list
                    </p>
                </div>
            </div>

            {/* Activity Section */}
            <div style={{ height: '14vh', marginTop: '-20px' }}>
                <div className="col-12">
                    <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
                        <p className="firstcolor m-0">
                            Activity
                        </p>
                        <GetIcon
                            iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
                            size={22}
                        />
                    </div>

                    {showActivity && (
                        <VersionHistory
                            doctype="Pick List"
                            docname={order_id}
                            activityboll={activityboll}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Tab1;
